<template>
    <div class="logo logo--button" v-if="isLoading" v-on:animationend="redirect">
        <router-link :to="{name:'Login'}" ><logo :width=85 :height=85></logo></router-link>
    </div>
</template>

<script>
    import SvgImage from "./subparts/SvgImage";

    export default {
        name: "KappLoading",
        data () {
            return {
                isLoading : true,
                LoadingImage : require( '@/assets/images/logo_grey.svg' )
            }
        },
        components : {
            'logo' : SvgImage
        },
        methods : {
            redirect : function ( evt ) {
                this.isLoading = false;
                this.$router.push({name : 'Login'});
                evt.target.style.opacity = 0;
            }
        },
        created () {
        }
    }
</script>

<style scoped>

    .logo.logo--button {
        transition: opacity .1s linear;
        animation: pulse 1.5s ease-in-out alternate 2 forwards;
    }
    @keyframes pulse {
        0% { transform: scale(1); }
        100% { transform: scale(1.3); }
        /*75% { transform: scale(1); }*/
    }
</style>


// WEBPACK FOOTER //
// src/components/KappLoading.vue